// Test IDs for the virtual showroom experience.
export const SHOWROOM = {
  enterButton: 'showroom-enter-button',
  callBar: 'showroom-call-bar',
  callLink: 'showroom-call-link',
  adminLink: 'showroom-admin-link',
  rangeLink: 'showroom-range-link',
  exitLink: 'showroom-exit-link',
  browseRoomButton: 'showroom-browse-room',
  roomNavPrefix: 'room-nav-',
  hotspotPrefix: 'hotspot-',
  dotPrefix: 'room-dot-',
  spaPanel: 'spa-detail-panel',
  spaPanelClose: 'spa-panel-close',
  togglePlus: 'spa-toggle-plus',
  toggleSelect: 'spa-toggle-select',
  configPrefix: 'urban-config-',
  speedPrefix: 'urban-speed-',
  ctaInterest: 'cta-express-interest',
  ctaInfo: 'cta-more-info',
  ctaCallback: 'cta-request-callback',
  leadForm: 'lead-form',
  leadName: 'lead-form-name',
  leadEmail: 'lead-form-email',
  leadPhone: 'lead-form-phone',
  leadMessage: 'lead-form-message',
  leadSubmit: 'lead-form-submit',
  leadSuccess: 'lead-form-success',
  buildOpen: 'build-save-open',
  buildForm: 'build-form',
  buildFirstName: 'build-first-name',
  buildSurname: 'build-surname',
  buildSuburb: 'build-suburb',
  buildPostcode: 'build-postcode',
  buildPhone: 'build-phone',
  buildEmail: 'build-email',
  buildMessage: 'build-message',
  buildSubmit: 'build-submit',
  buildSuccess: 'build-success',
};

export const RANGE = {
  page: 'range-page',
  backLink: 'range-back-link',
  catTabPrefix: 'range-cat-',        // + category
  filterPrefix: 'range-filter-',      // + facet-value
  clearFilters: 'range-clear-filters',
  cardPrefix: 'range-card-',          // + spa id
  comparePrefix: 'range-compare-',    // + spa id
  compareBar: 'range-compare-bar',
  compareOpen: 'range-compare-open',
  compareClear: 'range-compare-clear',
  compareModal: 'range-compare-modal',
  compareClose: 'range-compare-close',
  count: 'range-count',
};

export const ADMIN = {
  loginEmail: 'admin-login-email',
  loginPassword: 'admin-login-password',
  loginSubmit: 'admin-login-submit',
  logout: 'admin-logout',
  tabLeads: 'admin-tab-leads',
  tabSpas: 'admin-tab-spas',
  addSpa: 'admin-add-spa',
  spaForm: 'admin-spa-form',
  spaName: 'admin-spa-name',
  spaCategory: 'admin-spa-category',
  spaBrand: 'admin-spa-brand',
  spaTagline: 'admin-spa-tagline',
  spaDescription: 'admin-spa-description',
  spaSeats: 'admin-spa-seats',
  spaSize: 'admin-spa-size',
  spaImage: 'admin-spa-image',
  spaActive: 'admin-spa-active',
  spaSave: 'admin-spa-save',
  spaCancel: 'admin-spa-cancel',
  spaEditPrefix: 'admin-spa-edit-',
  spaDeletePrefix: 'admin-spa-delete-',
  leadRowPrefix: 'admin-lead-row-',
  leadStatusPrefix: 'admin-lead-status-',
};
